import { CurrencySchema } from '@vy/types';
import { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const ExchangeRateFormSchema = oz.object({
  invoiceCurrency: CurrencySchema,
  exchangeRate: oz.number().positive().nullable(),
});

export type ExchangeRateFormValues = oz.infer<typeof ExchangeRateFormSchema>;
export type ExchangeRateFormControl = Control<ExchangeRateFormValues>;
